/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import TextInput from '../../../components/Form/TextInput';

import { saveAuthData } from '../../../helpers/authStorage';
import AuthService from '../../../services/AuthService';
import { useUiContext } from '../../../context/UiContext';

const validationSchema = Yup.object({
  password: Yup.string().required('This field is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('This field is required'),
});

export default function SetPasswordPage({ reset }) {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState('');

  const token = searchParams.get('token');

  const navigate = useNavigate();

  const { showToast } = useUiContext();

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        let response;

        if (reset) {
          response = await AuthService.setNewPasswordAfterReset({
            token,
            password: values.password,
          });
        } else {
          response = await AuthService.acceptInviteAndSetPassword({
            inviteCode: token,
            password: values.password,
          });
        }

        showToast({
          text: 'Your password was successfully updated.',
          type: 'success',
        });

        if (reset) {
          saveAuthData({
            accessToken: response,
          });
          setTimeout(() => {
            navigate('/');
          }, 1500);
        } else {
          const { email } = response;

          await AuthService.login({ email, password: values.password }, () => {
            navigate('/');
          });
        }
      } catch (error) {
        console.log(error);
        setErrorMessage(
          error.response?.data?.message ?? 'Something went wrong'
        );
      }
    },
  });

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="bg-white dark:bg-slate-800 shadow-lg rounded-sm mb-8 p-8 w-96">
        <h1 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-5">
          Set Your Password
        </h1>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <TextInput
              label="Password"
              type="password"
              name="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              error={formik.errors.password}
              touched={formik.touched.password}
            />
          </div>
          <div className="mt-4">
            <TextInput
              label="Confirm password"
              type="password"
              name="confirmPassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.confirmPassword}
              error={formik.errors.confirmPassword}
              touched={formik.touched.confirmPassword}
            />
          </div>
          <button
            type="submit"
            className="btn bg-indigo-500 hover:bg-indigo-600 text-white w-full mt-8"
          >
            Set Password
          </button>
        </form>
        {errorMessage && (
          <div className="mt-5">
            <div className="bg-red-100 dark:bg-red-400/30 text-red-600 dark:text-red-400 px-3 py-2 rounded">
              <span className="text-sm">{errorMessage}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
